/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { ApiSrc } from "../../../resources/ApiSrc";
import { GetResultObject, PostRequest } from "../../API";

const TYPES = {
    REQUEST_RECEIVER_LIST: "REQUEST_RECEIVER_LIST",  
    REQUEST_RECEIVER_LIST_SUCCESS: "REQUEST_RECEIVER_LIST_SUCCESS",
    REQUEST_RECEIVER_LIST_FAILED: "REQUEST_RECEIVER_LIST_FAILED",    

    REQUEST_RECEIVER_DETAIL: "REQUEST_RECEIVER_DETAIL",
    REQUEST_RECEIVER_DETAIL_SUCCESS: "REQUEST_RECEIVER_DETAIL_SUCCESS",

    REQUEST_CREATE_RECEIVER: "REQUEST_CREATE_RECEIVER",
    REQUEST_CREATE_RECEIVER_SUCCESS: "REQUEST_CREATE_RECEIVER_SUCCESS",

    REQUEST_UPDATE_RECEIVER: "REQUEST_UPDATE_RECEIVER",
    REQUEST_UPDATE_RECEIVER_SUCCESS: "REQUEST_UPDATE_RECEIVER_SUCCESS",
};
  
const getReceiverList = (body, params) => {
    return (dispatch) => {
      dispatch({
        type: TYPES.REQUEST_RECEIVER_LIST,
        payload: {},
      });
      PostRequest(
          ApiSrc.LIST_RECEIVER, body, params
      ).then(result => {
        GetResultObject(result, 'data.content', 200, (data, page) => {
          dispatch({
            type: TYPES.REQUEST_RECEIVER_LIST_SUCCESS,
            payload: {data: data, ...page},});
          })    
       })
  
    }
}

const getReceiverDetail = (body) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_RECEIVER_DETAIL,
      payload: {},
    });
    PostRequest(
        ApiSrc.RECEIVER_DETAIL, body
    ).then(result => {
      GetResultObject(result, 'data', 200, (data, page) => {
        dispatch({
          type: TYPES.REQUEST_RECEIVER_DETAIL_SUCCESS,
          payload: {data: data, ...page},});
        })    
     })

  }
}

const createReceiver = (body) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_CREATE_RECEIVER,
      payload: {},
    });
    PostRequest(
        ApiSrc.CREATE_RECEIVER, body
    ).then(result => {
      GetResultObject(result, 'data', 200, (data, page) => {
        dispatch({
          type: TYPES.REQUEST_CREATE_RECEIVER_SUCCESS,
          payload: {data: data, ...page},});
        })    
     })
  }
}
const createReceiverSuccess = (data) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_CREATE_RECEIVER_SUCCESS,
      payload: {data: data}
    });    
  }
}


const updateReceiver = (body) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_UPDATE_RECEIVER,
      payload: {},
    });
    PostRequest(
        ApiSrc.UPDATE_RECEIVER, body
    ).then(result => {
      GetResultObject(result, 'data', 200, (data, page) => {
        dispatch({
          type: TYPES.REQUEST_UPDATE_RECEIVER_SUCCESS,
          payload: {data: data, ...page},});
        })    
     })
  }
}

const updateReceiverSuccess = (data) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_UPDATE_RECEIVER_SUCCESS,
      payload: {data: data}
    });    
  }
}

export default {
    TYPES, getReceiverList, getReceiverDetail, createReceiver, createReceiverSuccess, updateReceiver, updateReceiverSuccess
}